import Vue from 'vue';
import Vuex from 'vuex';
import createPersistedState from 'vuex-persistedstate';
import app from './modules/app';
import dict from './modules/dict';
import user from './modules/user';
import settings from './modules/settings';
import product from './modules/product';
import sysDict from "@/store/modules/sysDict";
import getters from './getters';

Vue.use(Vuex);

const store = new Vuex.Store({
  modules: {
    app,
    dict,
    user,
    settings,
    product,
    sysDict
  },
  getters,
  plugins: [
    createPersistedState({
      storage: window.localStorage, // 默认存储到 localStorage
      paths: ['product', 'user'], // 指定持久化的模块路径
    }),
  ],
});

export default store;
